import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

import clsx from 'clsx'
import { FormattedMessage, useIntl } from 'react-intl'

import useRenderSide from '@/hooks/auth/useRenderSide'
import { useSignInStore } from '@/hooks/stores/useSignInStore'

import Icon from '@/components/Icon'
import SupportPortalTab from '@/components/features/support/SupportPortalTab'

const SupportPage = () => {
  const router = useRouter()
  const { formatMessage } = useIntl()
  const { isSignedIn } = useRenderSide()
  const { openSignInModal } = useSignInStore()

  const writeToSupport = () => {
    if (isSignedIn) {
      router.push('/chats')
    } else {
      openSignInModal()
    }
  }

  return (
    <div className="pb-5 tablet:pb-8 desktop:pb-17">
      <Head>
        <title>
          {`${formatMessage({
            id: 'page.support',
            defaultMessage: 'Помощь'
          })} — Asterbit`}
        </title>
      </Head>
      <div className={clsx('flex items-center pb-5 max-desktop:pt-3')}>
        <div className="flex flex-auto items-center desktop:w-full">
          <h1
            className={clsx(
              'mr-auto overflow-hidden overflow-ellipsis whitespace-nowrap text-2xl',
              'font-medium leading-tight desktop:text-4xl desktop:leading-10'
            )}
          >
            <FormattedMessage
              {...{
                id: 'page.support',
                defaultMessage: 'Помощь'
              }}
            />
          </h1>
          <button
            className="flex items-center gap-1 font-medium text-primary-600"
            onClick={writeToSupport}
          >
            <Icon className="h-5 w-5" name="chat-alt-20" />
            <FormattedMessage
              {...{
                id: 'support.appeal.my',
                defaultMessage: 'Мои обращения'
              }}
            />
          </button>
        </div>
      </div>
      <SupportPortalTab />
    </div>
  )
}

export default SupportPage
